// tslint:disable:no-commented-code
// tslint:disable:no-duplicate-string
// tslint:disable:only-arrow-functions

import { Params } from '@angular/router';
import {
  IDynamicBindableValue,
  IDynamicBindableValueCombination,
  IDynamicItem,
} from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';
import { ensureArray, LinkInfo } from '@epicuro-next/utilities';

import { createInstanceWithChildren } from '../../utils/dynamic-items-utils';

export function createLink(
  id: string,
  routeProvider: IDynamicBindableValue | IDynamicBindableValueCombination,
  content: IDynamicItem | IDynamicItem[],
) {
  const link = createInstanceWithChildren({
    id,
    contentTypeId: 'dynamic-elements-link',
    eventHandlers: {} as IDynamicItem['eventHandlers'],
    if: undefined as IDynamicItem['if'],
    styles: {
      classes: [] as Exclude<
        Exclude<IDynamicItem['styles'], undefined>['classes'],
        undefined
      >,
      style: {
        color: 'var(--dark-mode-gray-600, #414141)',
        'margin-left': 'auto',
        __multiple__: {
          provider: 'id:root',
          property: 'seeMoreLinkStyle',
        },
      } as Exclude<
        Exclude<IDynamicItem['styles'], undefined>['style'],
        undefined
      >,
      variables: {
        '--link-color': 'inherit',
      },
      css: {} as Exclude<
        Exclude<IDynamicItem['styles'], undefined>['css'],
        undefined
      >,
    },
    data: {
      linkInfo: {
        values: [routeProvider],
        transform: function ([urlWithOptionalQueryParams]: [string]): LinkInfo {
          const linkInfo =
            window.neoclesDynamicFramework.recommendationsPanels.methods.urlToLinkInfo(
              urlWithOptionalQueryParams,
            );
          return linkInfo;
        }.toString(),
      },
    } as Exclude<IDynamicItem['data'], undefined>,
    inputs: {
      routerLink: {
        provider: 'self',
        property: 'linkInfo',
        transform: function (linkInfo: LinkInfo): string {
          return linkInfo.url;
        }.toString(),
      },
      params: {
        provider: 'self',
        property: 'linkInfo',
        transform: function (linkInfo: LinkInfo): Params | null {
          return linkInfo.params ?? null;
        }.toString(),
      },
      isStopPropagation: false,
    },
    children: ensureArray(content),
  });

  return link;
}
